export default [
  {
    path: '/adherents',
    name: 'adherents',
    component: () => import('@/views/adherents/Index.vue'),
    meta: {
      pageTitle: 'Gestion des adhérents',
      breadcrumb: [
        {
          text: 'Gestion des adhérents',
          active: true,
        },
      ],
      rights: [
        'ENTREPRISES:read',
        'EXTERNES_ENTREPRISES_OPENSOME:read'
      ]
    },
  },
  {
    path: '/adherents/details/:id',
    name: 'details-adherent',
    component: () => import('@/views/adherents/Details.vue'),
    meta: {
      pageTitle: 'Gestion des adhérents',
      breadcrumb: [
        {
          text: 'Gestion des adhérents',
          active: true,
        },
        {
          text: 'Modification'
        }
      ],
      rights: [
        'ENTREPRISES:read',
        'EXTERNES_ENTREPRISES_OPENSOME:read'
      ]
    },
  },
  {
    path: '/adherents/modification/:id',
    name: 'modification-adherent',
    component: () => import('@/views/adherents/Modification.vue'),
    meta: {
      pageTitle: 'Modification de l\'adhérent',
      breadcrumb: [
        {
          text: 'Gestion de l\'adhérent',
          active: true,
        },
        {
          text: 'Modification'
        }
      ],
      rights: [
        'ENTREPRISES:update'
      ]
    },
  },
  {
    path: '/opportunites/kanban',
    name: 'kanban-opportunites',
    component: () => import('@/views/opportunites/kanban/Index.vue'),
    meta: {
      pageTitle: 'Kanban des opportunités',
      breadcrumb: [
        {
          text: 'Gestion des opportunités',
          active: true,
        }
      ],
      rights: [
        'ENTREPRISES_OPPORTUNITES:read'
      ]
      },
  },
  {
    path: '/opportunites/list',
    name: 'list-opportunites',
    component: () => import('@/views/opportunites/list/Index.vue'),
    meta: {
      pageTitle: 'Liste des opportunités',
      breadcrumb: [
        {
          text: 'Gestion des opportunités',
          active: true,
        }
      ],
      rights: [
        'ENTREPRISES_OPPORTUNITES:read'
      ]
    },
  },
  {
    path: '/contrats/list',
    name: 'list-contrats',
    component: () => import('@/views/advancedContrats/Index.vue'),
    meta: {
      pageTitle: 'Liste des contrats',
      breadcrumb: [
        {
          text: 'Gestion des contrats',
          active: true,
        }
      ],
      rights: [
        'ENTREPRISES_CONTRATSV2:read'
      ]
    },
  },
]
  